import { IntlConsumer } from './IntlConsumer';
import { getLanguage, Language } from './IntlContext';

const translate = (language: Language, label: any, args: any[]) => {
    if (!language)
        return '';

    const result = label in language ? language[label] : label;

    return typeof result === 'function' ? result(...args) : result;
};

export const T = (props: { label: any, args?: any[] }) => (
    <IntlConsumer>
        { context => translate(context.language, props.label, props.args || []) }
    </IntlConsumer>
);

export const t = (label: any, ...args: any[]) => translate(getLanguage(), label, args);

export default t;
